import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

import type { Methodology } from '../../types'

/** @see {@link Methodology} */
export type GqlMethodology =
  | graphql.schema.SpaceRecordFunctionalMethodology.Manual
  | graphql.schema.SpaceRecordFunctionalMethodology.Vacant

/**
 * A Space Lite record only ever carries one of {@link Methodology}, so the
 * remaining members of the generated enum have nothing to map onto and read as
 * `undefined`.
 */
const FROM_GQL: Readonly<
  Partial<Record<graphql.schema.SpaceRecordFunctionalMethodology, Methodology>>
> = {
  [graphql.schema.SpaceRecordFunctionalMethodology.Manual]:
    ents.extra.space.Record.FunctionalUsage.Methodology.Manual,
  [graphql.schema.SpaceRecordFunctionalMethodology.Vacant]:
    ents.extra.space.Record.FunctionalUsage.Methodology.Vacant,
}

export const SPACE_RECORD_FUNCTIONAL_METHODOLOGY = transformers.combine(
  graphql.transformers.IN.enumeration<Methodology, GqlMethodology>({
    [ents.extra.space.Record.FunctionalUsage.Methodology.Manual]:
      graphql.schema.SpaceRecordFunctionalMethodology.Manual,
    [ents.extra.space.Record.FunctionalUsage.Methodology.Vacant]:
      graphql.schema.SpaceRecordFunctionalMethodology.Vacant,
  }),
  graphql.transformers.OUT.custom(
    (
      methodology: graphql.schema.SpaceRecordFunctionalMethodology | undefined,
    ) => (methodology ? FROM_GQL[methodology] : undefined),
  ),
)
